import script from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=0aa8f7b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa8f7b1"]])

export default __exports__